import { render, staticRenderFns } from "./Select893Button.vue?vue&type=template&id=ed1f7ba8&scoped=true"
import script from "./Select893Button.vue?vue&type=script&lang=js"
export * from "./Select893Button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1f7ba8",
  null
  
)

export default component.exports